import type { FlightOneWayInfo } from '@lt/api/dist/methods/packages/types';

import { DTOError } from 'src/error/errors/DTOError';

import { airlineDTO } from './airlineDTO';
import { airportInfoDTO } from './airportInfoDTO';
import { luggageDTO } from './luggageDTO';
import { transitionDTO } from './transitionDTO';
import { transitionTimeDTO } from './transitionTimeDTO';

export const flightOneWayInfoDTO = (data: unknown): FlightOneWayInfo => {
  if (
    data &&
    typeof data === 'object' &&
    'airline' in data &&
    'arrival' in data &&
    'class' in data &&
    'flight_id' in data &&
    'flight_no' in data &&
    'fuel_charge' in data &&
    'time' in data &&
    'departure' in data &&
    'destination' in data &&
    'luggage' in data &&
    'origin' in data &&
    'time' in data
  ) {
    return {
      airline: airlineDTO(data.airline),
      arrival: typeof data.arrival === 'string' ? data.arrival : '',
      business:
        'business' in data && typeof data.business === 'boolean'
          ? data.business
          : false,
      class:
        data.class === 'business' || data.class === 'econom'
          ? data.class
          : 'econom',
      departure:
        'departure' in data && typeof data.departure === 'string'
          ? data.departure
          : '',
      destination: airportInfoDTO(data.destination),
      direct:
        'direct' in data && typeof data.direct === 'boolean'
          ? data.direct
          : false,
      flight_id: typeof data.flight_id === 'string' ? data.flight_id : '',
      flight_no: typeof data.flight_no === 'string' ? data.flight_no : '',
      fuel_charge: typeof data.fuel_charge === 'number' ? data.fuel_charge : 0,
      luggage: luggageDTO(data.luggage),
      origin: airportInfoDTO(data.origin),
      time: typeof data.time === 'number' ? data.time : 0,
      type:
        'type' in data &&
        (data.type === 'regular' ||
          data.type === 'charter' ||
          data.type === 'block' ||
          data.type === 'n/a')
          ? data.type
          : 'n/a',
      transition:
        'transition' in data ? transitionDTO(data.transition) : undefined,
      transition_time:
        'transition_time' in data
          ? transitionTimeDTO(data.transition_time)
          : undefined,
    };
  }

  throw new DTOError('flightOneWayInfoDTO', data);
};
